
// Mutable array utilities
export const arrayUtils = {
    add: (array, item) => array.push(item),
    remove: (array, index) => array.splice(index, 1),
    clear: () => [],
    ensureArray: (array) => array || [],
};

// Immutable array utilities
export const immutableArrayUtils = {
    append: (array, item) => [...array, item],
    removeAt: (array, index) => array.filter((_, i) => i !== index),
    clear: () => [],
    ensureArray: (value) => (Array.isArray(value) ? value : []),
};
